import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from '~pages'
import { onSessionChangedInOtherTab } from '@/auth/utils'
import { extendRouteWithGuard } from '@/router/guards'
import { authMiddleware, isAuthRequired, languagePrefixMiddleware } from '@/router/middleware'
import { createBodyScroll } from '@/router/scroll'

const routes = [
  { path: '/home', redirect: '/' },
  ...setupLayouts(generatedRoutes),
].map(route => extendRouteWithGuard(route))

const bodyScroll = createBodyScroll()

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: bodyScroll.scrollBehavior,
})

router.beforeEach(bodyScroll.remember)
router.beforeEach(languagePrefixMiddleware)
router.beforeEach(authMiddleware)
router.afterEach(bodyScroll.track)

// A page that needs a signed-in user must not outlive its session: after a
// sign-out, or a sign-in as somebody else, in another tab its forms would send
// the previous user's data with the new tokens.
onSessionChangedInOtherTab(change => {
  const route = router.currentRoute.value
  if (!isAuthRequired(route))
    return

  if (change === 'ended')
    router.replace(authMiddleware(route) ?? { name: 'login' })
  else
    window.location.reload()
})

export default router
